import {
  buttonCx,
  buttonSize,
  buttonVariant
} from "./chunk-VVLIP2Q5.mjs";

// src/Button.tsx
import { forwardRef, julo, cx } from "@julo-ui/system";
import Typography from "@julo-ui/typography";
import { jsx } from "react/jsx-runtime";
var Button = forwardRef((props, ref) => {
  const {
    children,
    className,
    inverted,
    size = "regular",
    variant = "primary",
    block,
    sx,
    ...resProps
  } = props;
  return /* @__PURE__ */ jsx(Typography, { type: "body", size, bold: true, asChild: true, children: /* @__PURE__ */ jsx(
    julo.button,
    {
      ref,
      className: cx("julo-button", className),
      "data-button-size": size,
      "data-button-variant": variant,
      "data-button-variant-inverted": inverted,
      "data-button-block": block,
      sx: {
        ...buttonVariant[variant],
        ...buttonSize[size],
        ...sx
      },
      ...resProps,
      __css: buttonCx,
      children
    }
  ) });
});
Button.displayName = "Button";
var Button_default = Button;

export {
  Button_default
};
